import { render, staticRenderFns } from "./MenuTypeCard.vue?vue&type=template&id=28e28082&scoped=true"
import script from "./MenuTypeCard.vue?vue&type=script&lang=js"
export * from "./MenuTypeCard.vue?vue&type=script&lang=js"
import style0 from "./MenuTypeCard.vue?vue&type=style&index=0&id=28e28082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e28082",
  null
  
)

export default component.exports